<template>
    <div 
        data-module="card-list" 
        class="grid-default--3"
    >
        <div 
            v-for="(article, index) in articles" 
            class="card-container"
        >
            <!-- Skeleton element begins -->
            <article
                v-if="showSkeleton" 
                class="animate-pulse"
                :id="`teaser-${index}`"
            >
                <div class="card-image-box mb-2">
                    <div class="w-full aspect-4/3 object-cover h-full bg-gray-200 dark:bg-gray-700"></div>
                </div>
                <div class="card-text-box">
                    <div class="h-1 w-6/12 rounded bg-gray-200 dark:bg-gray-700 mb-1"></div>
                    <div class="h-1 rounded bg-gray-200 dark:bg-gray-700 mb-2"></div>
                    <div class="space-y-3">
                        <div class="grid grid-cols-3 gap-2 mb-1">
                            <div class="col-span-2 h-1 rounded bg-gray-200 dark:bg-gray-700"></div>
                            <div class="col-span-1 h-1 rounded bg-gray-200 dark:bg-gray-700"></div>
                        </div>
                        <div class="col-span-2 h-1 rounded bg-gray-200 dark:bg-gray-700"></div>
                    </div>
                </div>
            </article>
            <!-- Skeleton element ends -->

            <!-- Card element starts -->
            <FadeInTransition>
                <article
                    v-show="!showSkeleton"
                    class="card--vertical"
                    :id="`teaser-${index}`"
                    :ref="`teaser-${index}`"
                >
                    <div class="card-image-box">
                        <a v-if="article.extern_link === true" :href="article.extern_link_target" target="_blank">
                            <ImageWidget
                                :source="article.thumbnail"
                                :classes="['object-cover', 'w-full', 'h-full']"
                                :noSpacing="true"
                                :thumbnail="true"
                                @loaded="showContent"
                            ></ImageWidget>
                        </a>
                        <NuxtLink
                            v-else
                            :to="localePath(`${article.slug}`)"
                        >
                            <ImageWidget 
                                :source="article.thumbnail"
                                :classes="['object-cover', 'w-full', 'h-full']"
                                :noSpacing="true"
                                @loaded="showContent"
                            ></ImageWidget>
                        </NuxtLink>
                    </div>
                    <div class="card-text-box">
                        <div class="card-teaser" v-html="article.teaser_text"></div>
                            <a v-if="article.extern_link === true" :href="article.extern_link_target" target="_blank" class="button cta--default flex-row inline-flex" :aria-label="globals.pagecontent.article_button"
                            >
                                <span class="label">{{ globals.pagecontent.article_button }}</span>
                                <span class="basis-auto">
                                    <div class="circle circle-default"></div>
                                </span>

                            </a>
                            <NuxtLink
                                v-else
                                class="button cta--default flex-row inline-flex"
                                :to="localePath(`${article.slug}`)"
                            >
                                <span class="label">{{ globals.pagecontent.article_button }}</span>
                                <span class="basis-auto">
                                    <div class="circle circle-default"></div>
                                </span>
                            </NuxtLink>
                    </div>
                </article>
            </FadeInTransition>
            <!-- Card element ends -->
        </div>
    </div>
</template>

<script setup lang="ts">
	import { useBackendApiGet } from "@/composables/useBackendApi"
	import { type AuthResponse } from '@/types/AuthTypes'

    const localePath = useLocalePath()

    const requestStore = useRequestStore()
    const { globals } = storeToRefs(requestStore)
    const route = useRoute()
    const { locale } = useI18n()
    const { loggedIn, showPreviewLayout, pageID } = storeToRefs(requestStore)

    const showSkeleton = ref<boolean>(true)
    const articles = ref<any>([])

    const getDynamicArticleTeaserData = async () => {
        try {
            const data = await useBackendApiGet<AuthResponse>(`v1/articles/${locale.value}?articleID=${pageID.value}`)

            if(data) {
                articles.value = data
            }
        } catch (e) {
            console.error(e)        
        }
    }

    const showContent = () => {
        showSkeleton.value = false
    }

    watch(
        () => route.path,
        async () => {
            await getDynamicArticleTeaserData()
        },
        { immediate: true, deep: true }
    )
</script>

<style scoped>

</style>